import { render, staticRenderFns } from "./main.vue?vue&type=template&id=70539129&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=70539129&prod&lang=less&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=70539129&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70539129",
  null
  
)

export default component.exports